import { ErrorHandler, Injectable } from '@angular/core';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AppSettings } from 'src/app/configs/app.settings';

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggingService implements ErrorHandler {

  init() {
    console.log('error logging service loaded!');

    // clear refreshAttempts after a long wait, cause it would seem the app is working
    setTimeout(() => {
      sessionStorage.removeItem('refreshattempts');
    }, 60000);
  }

  handleError(error: Error): void {
    try {
      console.error('ErrorLoggingService: error:' + error.message, error);

      let errMsg = error.message;

      // check if this is a chunk load error before we save the error to db
      // so we can include some analytics about this erro, then, try reloading
      const chunkFailedMessage = /Loading chunk/;
      let loadChunkErr = false;
      let refreshAttempts = 0;
      if (chunkFailedMessage.test(error.message)) {
        loadChunkErr = true;
        const refreshAttemptsStored = sessionStorage.getItem('refreshattempts');
        if (refreshAttemptsStored != null) {
          refreshAttempts = +refreshAttemptsStored;
        }
        errMsg = 'Load Chunk Error, refreshes attempted ' + refreshAttempts;
      }


      const errorData = {
        message: errMsg,
        stack: error.stack,
        timestamp: new Date(),
        version: AppSettings.version,
        build: AppSettings.build + '',
        agent: window.navigator.userAgent,
        browser: window.navigator.vendor,
        app: 'RaffleRocket Client'
      };

      // can't use post in case we do refresh for failed chunk load,
      // as that causes browser to terminate any http connections
      //this.post(errorData, this.endpoint);

      // instead we'll use built in browser API call fetch, which has an option to
      // 'keepalive', which allows the request to complete even if the page unloads.
      // So like a fire and forget similar to sendBeacon, except with fetch you can
      // provide auth header, and apparently sendBeacon is at risk of being blocked 
      // by ad blockers
      ServiceHelper.httpSvc.post(errorData, `${AppSettings.cbsApiUrl}/errors`);

      if (loadChunkErr) {
        if (refreshAttempts < 3) {
          refreshAttempts++;
          sessionStorage.setItem('refreshattempts', refreshAttempts.toString());
          window.location.reload();
        } else {
          ServiceHelper.displayAlert('Oops, the Internet Burped!', 'We couldn\'t find a file we need, try ' +
            'refreshing the page! If that doesn\'t work, contact us at support@raffle-rocket.com');
          return;
        }
      }

    } catch (e) {
      console.error('error trying to log javascript error', e);
    }
  }
}
